export enum RoutePath {
  Login = '/login',
  // AUT-39: WEB-005. Was '/sign-up' -- a dead enum member registered in no
  // <Route>, backed by no page, referenced by nothing but its own
  // declaration (verified by grep, one hit). A rename, not a redirect
  // problem (components/account.md § "/signup -- the screen that does
  // nothing, on purpose").
  SignUp = '/signup',

  Home = '/',
  Dashboard = '/dashboard',
  BrandIntelligence = '/brand-intelligence',
  RankTracker = '/rank-tracker',
  KeywordTrends = '/keyword-trends',
  BrandContext = '/brand-context',
  KeywordLandscapes = '/keyword-landscapes',
  KeywordLandscapeDetail = '/keyword-landscapes/:instanceId',
  ABTests = '/ab-tests',
  CreateABTest = '/create-ab-test',
  SearchTerms = '/search-terms',
  SPI = '/spi',
  Products = '/products',
  ProductDetail = '/products/:productId',
  ProductDetailSeoInsights = '/products/:productId/seo-insights',
  ProductDetailKeywords = '/products/:productId/keywords',
  ProductDetailLandscapes = '/products/:productId/landscapes',
  ProductDetailLandscapeDetail = '/products/:productId/landscapes/:landscapeId',
  ProductDetailAbTests = '/products/:productId/ab-tests',
  ProductDetailSearchTerms = '/products/:productId/search-terms',
  ProductDetailContentScorecard = '/products/:productId/content-scorecard',
  ReportPreview = '/report/preview',
  ReportDetail = '/report/:reportId',
  Profile = '/profile',
  Settings = '/settings',
  DeveloperHandoff = '/developer-handoff',
  SignalGuide = '/signal-guide',
  /** AUT-399: a staging post that mints the short-lived SSO link, so the sidebar entry can be a real link. */
  AdminPanel = '/admin-panel',
  Analytics = '/analytics',
  AnalyticsBrandComparison = '/analytics/brand-comparison',
  AnalyticsBrandSignals = '/analytics/brand-signals',

  NotFound = '/404',

  AcceptInvitation = '/accept-invitation',

  PublicShare = '/share/:token',

  // AUT-39: WEB-002/WEB-003. Neither route sits under GuestRoute -- a reset
  // link may be opened by a browser still holding a stale session, and
  // GuestRoute would bounce that visitor to `/` before they can finish
  // (components/account.md § The SPA).
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
}